import PropTypes from 'prop-types';
import { useConfig } from "context/ConfigContext";
import HTMLContainer from "components/ui/HTML/HTMLContainer";

const ResponsiveImage = ({ value, defaultImage, className }) => {
  const config = useConfig();
  if (value) {
    // the path of the rendered image is relative, make it absolute here so it can be used when running on localhost
    let valueWithAbsolutePaths = value;
    const filePaths = [
      '/system/files',
      '/sites/default/files',
    ];
    filePaths.forEach(value => valueWithAbsolutePaths = valueWithAbsolutePaths.replaceAll(value, config.host + value))
    return <HTMLContainer value={ valueWithAbsolutePaths } className={ className }/>;
  }

  if (defaultImage) {
    return <div className={ className }><img src={ defaultImage } alt="" /></div>
  }

  return null;
}

ResponsiveImage.propTypes = {
  value: PropTypes.string,
  defaultImage: PropTypes.any,
  className: PropTypes.string,
}

export default ResponsiveImage;
